'use strict';

(function (global) {

  /**
   * @class ExcelDocumentPostprocessor
   * @classdesc Подготовка к предпросмотру документов MS Excel.
   * @hideconstructor
   * @namespace window.Core.preview
   * @since 5.7.0
   */
  class ExcelDocumentPostprocessor extends global.BaseDocumentPostprocessor {

    // Костыль для IE10, иначе он не может наследовать родительский static метод с babel-preset-env 1.6.1
    /**
     * @see BaseDocumentPostprocessor.prepare
     */
    static prepare(jFrame, filePath, extension) {
      return super.prepare(jFrame, filePath, extension);
    }

    // Костыль для IE10, иначе он не может наследовать родительский static метод с babel-preset-env 1.6.1
    /**
     * @see BaseDocumentPostprocessor._addFilesToHead
     */
    static _addFilesToHead(jFrameContents, filePath) {
      return super._addFilesToHead(jFrameContents, filePath);
    }

    /**
     * @see BaseDocumentPostprocessor._prepareContents
     */
    static _prepareContents(jFrame) {
      this._openLinksToExternalResourcesOnNewTabs(jFrame);
      this._fixHttpLinks(jFrame);
      this._setBodyColor(jFrame);
      this._removeTabScroller(jFrame);
      this._onTabSwitch(jFrame);
    }

    /**
     * Установка белого фона таблицы.
     *
     * @method _setBodyColor
     * @param {object} jFrame jQuery-объект iframe предпросмотра.
     * @private
     * @static
     */
    static _setBodyColor(jFrame) {
      const jPreviewBody = $(jFrame[ 0 ].contentDocument.body);
      const jSheetFrame = jPreviewBody.find('frame[name=frSheet]');
      if (jSheetFrame.length) {
        const sheetFrameBody = jSheetFrame[ 0 ].contentDocument.body;
        sheetFrameBody.style.backgroundColor = '#fff';
      } else {
        jPreviewBody.css('backgroundColor', '#fff');
      }
    }

    /**
     * Убрать скроллер листов документа.
     *
     * @method _removeTabScroller
     * @param {object} jFrame jQuery-объект iframe предпросмотра.
     * @private
     * @static
     */
    static _removeTabScroller(jFrame) {
      const jPreviewBody = $(jFrame[ 0 ].contentDocument.body);
      const jFrameSet = jPreviewBody.find('frameset');
      const jScrollFrame = jFrameSet.find('frame[name=frScroll]');
      if (jScrollFrame.length) {
        const jTabsFrame = jPreviewBody.find('frame[name=frTabs]');
        const jSheetFrame = jPreviewBody.find('frame[name=frSheet]');
        jSheetFrame.after(jTabsFrame);
        jScrollFrame.parent().remove();
      }
    }

    /**
     * Событие переключения листов Excel-документа.
     *
     * @method _onTabSwitch
     * @param {object} jFrame jQuery-объект iframe предпросмотра.
     * @private
     * @static
     */
    static _onTabSwitch(jFrame) {
      const jPreviewBody = $(jFrame[ 0 ].contentDocument.body);

      // Добавить и скрыть спиннер, отображаемый при переключении листов.
      const jSpinner = $('<img src="/images/spinner.gif" style="margin: calc(50vh - 100px) auto 0; width: 16px;" />');
      jFrame.before(jSpinner);
      jSpinner.hide();

      // При переключении на другой лист Excel происходит установка нового url во frame.
      // По нажатии на кнопку скрываем весь iframe и отображаем спиннер.
      const jTabsFrame = jPreviewBody.find('frame[name=frTabs]');
      const jSheetFrame = jPreviewBody.find('frame[name=frSheet]');
      if (jTabsFrame.length && jSheetFrame.length) {
        const jTabFrameBody = $(jTabsFrame[ 0 ].contentDocument.body);
        jTabFrameBody.find('a').bind('click', () => {
          jSpinner.show();

          // HACK: скрываем за счет visibility, т.к. в IE11 после скрытия
          // через display: none iframe перестает отображаться вообще.
          jFrame.css('visibility', 'hidden');

          // После загрузки страницы устанавливаем фон и скрываем спиннер.
          jSheetFrame.one('load', () => {
            this._openLinksToExternalResourcesOnNewTabs(jFrame);
            this._fixHttpLinks(jFrame);

            this._setBodyColor(jFrame);
            jSpinner.hide();
            jFrame.css('visibility', 'visible');
          });
        });
      }
    }

    /**
     * Сделать так, чтоб ссылки на внешние ресурсы открывались в новом окне.
     *
     * @method _openLinksToExternalResourcesOnNewTabs
     * @param {object} jFrame jQuery-объект iframe предпросмотра.
     * @private
     * @static
     */
    static _openLinksToExternalResourcesOnNewTabs(jFrame) {
      let jDocBody = jFrame.contents().find('body');
      if (!jDocBody.length) {
        const jExcelSheetFrame = jFrame[0].contentWindow.frames['frSheet'];
        if (jExcelSheetFrame) {
          jDocBody = $(jExcelSheetFrame.document).find('body');
        }
      }

      jDocBody.find('a').each((index, domElement) => {
        const jAnchorTag = $(domElement);
        const href = jAnchorTag.attr('href');
        if (href && !href.match('^#')) {
          jAnchorTag.attr('target', '_blank');
        }
      });
    }

    /**
     * Исправление запрета смешанного содержимого, когда ссылка http в iframe
     * блочится, пробрасываем её на родительский документ и открываем из него
     *
     * @method _fixHttpLinks
     * @param {object} jFrame jQuery-объект iframe предпросмотра.
     * @private
     * @static
     * @see #81595
     */
    static _fixHttpLinks(jFrame) {
      function getFrame(name) {
        return jFrame.contents().find('frame[name=' + name + ']').get(0);
      }

      function rebindPassthrow() {
        const jFrameSheet = getFrame('frSheet');
        if (jFrameSheet) {
          $(jFrameSheet.contentWindow.document).find('a').unbind('click.pass').bind('click.pass', function () {
            window.open($(this).attr('href'));
            return false;
          });
        }
      }

      const jFrameTabs = getFrame('frTabs');
      if (jFrameTabs) {
        $(jFrameTabs.contentWindow.document).find('a').bind('click.pass', function () {
          setTimeout(function () {
            rebindPassthrow();
          }, 300);
        });
      }
    }

  }

  global.ExcelDocumentPostprocessor = ExcelDocumentPostprocessor;

})(window.Core.preview);